import axios from "@/utils/axios";
import {
  QueryClient,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";

const getMe = async (): Promise<{
  data: {
    id: string;
    name: string;
    last_name: string;
    email: string;
    dui: string;
    phone_number: string;
    department_id: string;
    registered_position_id: string;
    assigned_institution_id: string;
    has_permission: boolean;
    groups: Array<{
      id: string;
      name: string;
      description: string;
      created_at: string;
      updated_at: string;
      deleted_at: string | null;
      type: string;
      pivot: {
        user_id: string;
        group_id: string;
        priority: number;
        seniority: number;
        created_at: string;
        updated_at: string;
      };
    }>;
  };
}> => {
  const response = await axios.get("/admin/v1/user/profile");
  return response.data;
};

export const useGetMe = () => {
  return useQuery({
    queryKey: ["me"],
    queryFn: getMe,
  });
};

export const useUpdateProfile = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: {
      name?: string;
      last_name?: string;
      phone_number: string;
      email?: string;
      department_id?: string;
      registered_position_id?: string;
      assigned_institution_id?: string;
    }) => {
      const response = await axios.patch("/admin/v1/user/profile", data);
      return response.data;
    },
    onSuccess() {
      // Invalidate the query to refetch the updated profile
      queryClient.invalidateQueries({ queryKey: ["me"] });
    },
  });
};

export const preLoadProfileInfo = (queryClient: QueryClient) => {
  return async () => {
    try {
      const data = await queryClient.ensureQueryData({
        queryKey: ["me"],
        queryFn: async () => getMe(),
        staleTime: 5 * 60 * 1000, // 5 minutes
      });
      return { data };
    } catch (error) {
      console.log("Error fetching role for breadcrumb:", error);
      return {
        error: error instanceof Error ? error.message : "Unknown error",
      };
    }
  };
};
